import script from "./Contact.vue?vue&type=script&setup=true&lang=ts"
export * from "./Contact.vue?vue&type=script&setup=true&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=885c8396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885c8396"]])

export default __exports__